export default "__VITE_ASSET__CpfmmK7$__"